import { useEffect, useState } from 'react';

import {
  DealerPanelContent,
  IDealerPanelContent,
} from '@/components/sections/dealer/panel/content';
import { DealerPanelDrawer } from '@/components/sections/dealer/panel/drawer';
import { DealerPanelHeader } from '@/components/sections/dealer/panel/header';
import {
  ScrollArea,
  ScrollAreaCorner,
  ScrollAreaScrollbar,
  ScrollAreaThumb,
  ScrollAreaViewport,
} from '@/components/shared/element/scroll-area';
import { Box } from '@/components/shared/layout/box';
import { Flex } from '@/components/shared/layout/flex';
import type { IDealer } from '@/types/dealer/dealer';

interface DealerPanelProps {
  isOpen: boolean;
  panel: IDealerPanelContent;
  dealer?: IDealer;
  onClose: () => void;
}

export const DealerPanel = ({
  panel,
  dealer,
  isOpen,
  onClose,
}: DealerPanelProps) => {
  const [selectedDealerData, setSelectedDealerData] = useState<
    IDealer | undefined
  >(dealer);

  useEffect(() => {
    if (dealer) setSelectedDealerData(dealer);
  }, [dealer]);

  if (!selectedDealerData) return <></>;

  return (
    <DealerPanelDrawer isOpen={isOpen}>
      <Box
        position="relative"
        backgroundColor="white"
        boxShadow="200"
        height="full"
        data-test="dealer_result_container"
      >
        <Flex direction="column" css={{ height: '100%' }}>
          <DealerPanelHeader
            headerText={selectedDealerData.mirai?.name_th ?? ''}
            onClose={onClose}
          />
          <Box
            paddingX={{
              '@initial': '4',
              '@xs': '6',
            }}
            paddingY="6"
            paddingLeft={{
              '@2xl': '7',
            }}
            overflow="hidden"
            css={{
              flexGrow: '1',
              maxHeight: '100%',
            }}
          >
            <ScrollArea type="auto">
              <ScrollAreaViewport>
                <DealerPanelContent
                  address={selectedDealerData.mirai?.address}
                  dealer={selectedDealerData}
                  panel={panel}
                />
              </ScrollAreaViewport>
              <ScrollAreaScrollbar orientation="vertical">
                <ScrollAreaThumb />
              </ScrollAreaScrollbar>
              <ScrollAreaCorner />
            </ScrollArea>
          </Box>
        </Flex>
      </Box>
    </DealerPanelDrawer>
  );
};

DealerPanel.displayName = 'SectionDealerPanel';
